export default __webpack_public_path__ + "static/media/web-design.37370677.svg";